import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import useWebGalleryPasswordEntryState from './useWebGalleryPasswordEntryState';
import InputGroup from '../../../../components/global/InputGroup';
import Button from '../../../../components/global/Button';
import Alert from '../../../../components/global/Alert';
import BoxedItem from '../../../../components/global/BoxedItem';
import LockIcon from '../../../../components/icons/LockIcon';
import { getAccountLogoFromHierarchyItem } from './helpers';
import Logo from '../../../../components/global/Logo';

const WebGalleryPasswordEntry = () => {
  const [password, setPassword] = useState('');
  const history = useHistory();
  const location = useLocation();
  const { onFormSubmit, loading, submitting, error, hierarchyItem } =
    useWebGalleryPasswordEntryState({
      password,
      onVerified: () => {
        const { next } = qs.parse(location.search);
        history.replace(next);
      },
    });

  const accountLogoUrl = getAccountLogoFromHierarchyItem(hierarchyItem);

  return (
    <div className="web-gallery-access-container">
      <header className="web-gallery-access-header">
        {accountLogoUrl && (
          <img
            src={accountLogoUrl}
            alt=""
            className="web-gallery-access-header-account-logo"
          />
        )}

        <Logo iconOnly className="web-gallery-access-header-waldo-logo" />
      </header>

      <BoxedItem className="web-gallery-access-box">
        <h3 className="web-gallery-access-box-title">
          <LockIcon /> Restricted Content
        </h3>

        <p className="text-center">
          Please provide the gallery&rsquo;s password to view its contents.
        </p>

        <form onSubmit={onFormSubmit} className="web-gallery-password-form">
          <InputGroup
            id="password"
            type="password"
            label="Password"
            labelSrOnly
            placeholder="Password..."
            required
            addon={<LockIcon size={12} />}
            value={password}
            onChange={event => setPassword(event.target.value)}
            disabled={loading}
            wrapperClassName="mb-2"
          />

          {error && (
            <Alert className="mb-2" type="danger">
              {error}
            </Alert>
          )}

          <Button
            btnBlock
            type="submit"
            disabled={submitting || loading || !password}
            className="mt-0 text-extra-bold"
          >
            {submitting ? 'Please wait...' : 'Continue'}
          </Button>
        </form>
      </BoxedItem>
    </div>
  );
};

export default WebGalleryPasswordEntry;
